import { useMutation } from '@tanstack/react-query';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AcademiaResponse } from '../../../types/common';
import { Expertise, ExpertiseReqBody } from '../../../types/expertise';

const useUserExpertiseActions = (whichAction: '') => {
  const updateUserExpertiseHandler = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: ExpertiseReqBody;
    }): Promise<AcademiaResponse<Expertise>> => {
      const response = await getPrivateAxiosInstance('user').patch(
        '/user/expertise/partial/update/',
        body
      );

      return response.data;
    },
  });

  return {
    updateUserExpertiseHandler,
  };
};

export default useUserExpertiseActions;
